export class Parser {
  templateMatcher = /{{\s?([^{}\s]*)\s?}}/g;
  interpolate(expr: string | Function, params?: any): string {
    let result: string;

    if (typeof expr === 'string') {
      result = this.interpolateString(expr, params);
    } else if (typeof expr === 'function') {
      result = this.interpolateFunction(expr, params);
    } else {
      // this should not happen, but an unrelated TranslateService test depends on it
      result = expr as string;
    }

    return result;
  }

  isDefined(value: any): boolean {
    return typeof value !== 'undefined' && value !== null;
  }

  getValue(target: any, key: string): any {
    const keys = typeof key === 'string' ? key.split('.') : [key];
    key = '';
    do {
      key += keys.shift();
      if (
        this.isDefined(target) &&
        this.isDefined(target[key]) &&
        (typeof target[key] === 'object' || !keys.length)
      ) {
        target = target[key];
        key = '';
      } else if (!keys.length) {
        target = undefined;
      } else {
        key += '.';
      }
    } while (keys.length);

    return target;
  }

  interpolateFunction(fn: Function, params?: any) {
    return fn(params);
  }

  interpolateString(expr: string, params?: any) {
    if (!params) {
      return expr;
    }

    return expr.replace(
      this.templateMatcher,
      (substring: string, key: string) => {
        const result = this.getValue(params, key);
        return this.isDefined(result) ? result : substring;
      }
    );
  }
}
